import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import ImageUpload from '../components/ImageUpload';
import '../components/ImageUpload.css';

const EditProduct = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(true);

    const [formData, setFormData] = useState({
        name: '',
        description: '',
        price: '',
        category: 'chess-sets',
        imageUrl: '',
        stock: '',
        featured: false
    });

    const categories = [
        { value: 'chess-sets', label: 'Chess Sets' },
        { value: 'boards', label: 'Boards' },
        { value: 'pieces', label: 'Pieces' },
        { value: 'clocks', label: 'Clocks' },
        { value: 'books', label: 'Books' },
        { value: 'accessories', label: 'Accessories' }
    ];

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const res = await axios.get(`${config.API_URL}/products/${id}`);
                const product = res.data;
                setFormData({
                    name: product.name,
                    description: product.description,
                    price: product.price,
                    category: product.category,
                    imageUrl: product.imageUrl,
                    stock: product.stock,
                    featured: product.featured || false
                });
                setLoading(false);
            } catch (err) {
                console.error("Error fetching product", err);
                setError("Failed to load product");
                setLoading(false);
            }
        };

        if (id) fetchProduct();
    }, [id]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        try {
            const token = localStorage.getItem('token');
            const productData = {
                ...formData,
                price: parseFloat(formData.price),
                stock: parseInt(formData.stock)
            };

            await axios.put(`${config.API_URL}/products/${id}`, productData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            setSuccess('Product updated successfully!');

            // Redirect to shop after 2 seconds
            setTimeout(() => navigate('/shop'), 2000);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update product');
        }
    };

    if (loading) return <div className="container">Loading...</div>;

    return (
        <div className="container" style={{ paddingTop: '2rem' }}>
            <div className="form-container">
                <h1>Edit Product</h1>
                {error && <div className="error">{error}</div>}
                {success && <div className="success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Product Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            rows="4"
                            required
                        />
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <label>Price (KSh)</label>
                            <input
                                type="number"
                                name="price"
                                value={formData.price}
                                onChange={handleChange}
                                step="0.01"
                                min="0"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>Stock Quantity</label>
                            <input
                                type="number"
                                name="stock"
                                value={formData.stock}
                                onChange={handleChange}
                                min="0"
                                required
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label>Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            required
                        >
                            {categories.map(cat => (
                                <option key={cat.value} value={cat.value}>
                                    {cat.label}
                                </option>
                            ))}
                        </select>
                    </div>

                    <ImageUpload
                        label="Product Image"
                        value={formData.imageUrl}
                        onChange={(url) => setFormData(prev => ({ ...prev, imageUrl: url }))}
                    />

                    <div className="form-group">
                        <label className="checkbox-label">
                            <input
                                type="checkbox"
                                name="featured"
                                checked={formData.featured}
                                onChange={handleChange}
                            />
                            Feature this product under "Featured Chess Sets"
                        </label>
                    </div>

                    <button type="submit" className="btn">Update Product</button>
                </form>
            </div>
        </div>
    );
};

export default EditProduct;
